import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from "vue";
import "@/plugins/Translation";
import useTranslations from "@/composables/useTranslations";
import ElErrorLandingPage from "@/components/El/ErrorLandingPage/ElErrorLandingPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WebComponentErrorPausedCode',
  props: {
    _language: { default: "" }
  },
  setup(__props: any) {

const props = __props as { _language: string }



const { $t, validate } = useTranslations();
// REQUIRED: Validate language prop
validate(props._language);

return { __sfc: true,props, $t, validate, ElErrorLandingPage }
}

})